import { HTTP } from '@/common/utils/http';
import { PaginationParams } from '@/common/utils/pagination-params';
import { mapBodyParams } from '@/common/utils/mapBodyParams';
import { QueryParams} from '@/common/utils/query-params';

export const SchoolClassService = {
    createClass(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/classes`, form);
    },

    editClass(schoolId, classId, form) {
        return HTTP.put(`/schools/${schoolId}/classes/${classId}`, form);
    },

    createDraftClass(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/classes-draft`, form);
    },

    editDraftClass(schoolId, classId, form) {
        return HTTP.put(`/schools/${schoolId}/classes/${classId}/draft`, form);
    },
    activateDraftClass(schoolId, classId, form) {
        return HTTP.put(`/schools/${schoolId}/classes/${classId}/draft-activate`, form);
    },


    getClasses(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/no-auth/schools/${schoolId}/classes`);
        return HTTP.get(url, { cache: false });
    },

    getClassDates(schoolId, dateFrom, dateTo) {
        return HTTP.get(`/schools/${schoolId}/classes/calendar?dateFrom=${dateFrom}&&dateTo=${dateTo}`, { cache: false });
    },

    getClassesByInstructor(schoolId, instructorId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/classes/instructor/${instructorId}`, { cache: false });
        return HTTP.get(url);
    },

    getClassesGeneralInfo(schoolId) {
        return HTTP.get(`/schools/${schoolId}/classes/statistics`);
    },

    getClassDetailsGeneralInfo(schoolId, classId) {
        return HTTP.get(`/schools/${schoolId}/classes/${classId}/statistics`);
    },

    getClass(schoolId, classId) {
        return HTTP.get(`/schools/${schoolId}/classes/${classId}`, { cache: false });
    },

    deleteClass(schoolId, classId) {
        return HTTP.delete(`/schools/${schoolId}/classes/${classId}`);
    },

    deleteMultipleClasses(schoolId, classIds) {
        return HTTP.delete(`/schools/${schoolId}/classes?ids=${classIds}`);
    },

    bulkUpdateClasses(schoolId, classIds, form) {
        const body = {
            ids: classIds,
            ...form
        };
        return HTTP.patch(`/schools/${schoolId}/classes`, mapBodyParams(body));
    },

    updateClassSettings(schoolId, settingsForm) {
        return HTTP.put(`/schools/${schoolId}/parent-portal-settings/classes`, settingsForm);
    },

    getClassSettings(schoolId) {
        return HTTP.get(`/schools/${schoolId}/parent-portal-settings/classes`);
    },

    sendBulkEmail(schoolId, body, attachment) {
        const headers = {
            'Content-type': 'multipart/form-data'
        };
        const formData = new FormData();
        const form = JSON.stringify(body);
        formData.append("emailForm", form);
        Object.values(attachment).forEach((el) => {
            formData.append(`attachment`, el);
        });
        return HTTP.post(`/schools/${schoolId}/classes/parent-emails`, formData, { headers });
    },

    sendBulkSMS(schoolId, body) {
        return HTTP.post(`/schools/${schoolId}/classes/parent-sms`, body);
    },

    getClassAddOns(schoolId, classId) {
        return HTTP.get(`schools/${schoolId}/classes/${classId}/add-ons`);
    },

    getClassName(schoolId, classId) {
        return HTTP.get(`/schools/${schoolId}/classes/${classId}/name`);
    },

    getXlsFileFieldNames(schoolId) {
        return HTTP.get(`/schools/${schoolId}/classes/xls-fields`);
    },

    getClassesBySchoolXls(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/classes/xls`, form);
    },

    getClassesBySchoolXlsBySchedule(schoolId, ids) {
        return HTTP.get(`/schools/${schoolId}/classes/schedule?ids=${ids}`);
    },
    
    generateCustomFormReport(schoolId, form) {
        return HTTP.post(`/reports/schools/${schoolId}/custom-forms`, form);
    },

    getCopyLinkClass(schoolId, classId) {
        return HTTP.get(`/schools/${schoolId}/classes/${classId}/copy-link`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/pages/classes.service.js